import React from "react";
import TitlePage from "../../components/section/TitlePage/Titlepage";
import Filter from "./Components/Filter";
import { TaxInvoicesTable } from "./Components/Table";

const TaxInvoices = () => {
  return (
    <div>
      <TitlePage title="세금계산서" />
      <Filter />
      <TaxInvoicesTable />
    </div>
  );
};

export default TaxInvoices;
